import React from 'react';
import './ConfirmationModal.css';

const ConfirmationModal = ({ show, message, onConfirm, onCancel }) => {
  if (!show) {
    return null; // Ha nincs megjelenítve, akkor ne renderelje a komponenst
  }

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Megerősítés szükséges</h2>
        <p>{message}</p>
        <div className="modal-buttons">
          <button onClick={onCancel} className="modal-button cancel">Mégse</button>
          <button onClick={onConfirm} className="modal-button confirm">Megerősítés</button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
